export class TicketInStock {
  id?: number;
  ticket_type_id?: number;
  price?: number;
  limit_number?: number;
  ticket_price_id?: number;
  date?: string;
}
